
import { useState } from 'react';
import { RevenueSplit } from '../types/masterLicenseSettings';
import { v4 as uuidv4 } from 'uuid';

export const useRevenueSplitManagement = () => {
  const [isSavingRevenueSplits, setIsSavingRevenueSplits] = useState(false);

  const handleRevenueSplitAdd = (split: Partial<RevenueSplit>) => {
    const newSplit: RevenueSplit = {
      id: uuidv4(),
      volumeThreshold: split.volumeThreshold || 0,
      masterLicensePercentage: split.masterLicensePercentage || 70,
      resellerPercentage: split.resellerPercentage || 30,
      isActive: split.isActive !== undefined ? split.isActive : true
    };
    return newSplit;
  };

  const handleSaveRevenueSplits = async (): Promise<boolean> => {
    if (isSavingRevenueSplits) return false;
    setIsSavingRevenueSplits(true);
    
    try {
      await new Promise(resolve => setTimeout(resolve, 1500));
      return true;
    } catch (error) {
      console.error('Error saving revenue splits:', error);
      return false;
    } finally {
      setIsSavingRevenueSplits(false);
    }
  };

  return {
    isSavingRevenueSplits,
    handleRevenueSplitAdd,
    handleSaveRevenueSplits,
  };
};
